import { type AcademySiteStatus, academySiteSchema } from "../schemas/academy-site";
import { fetchApi } from "./internal";

export const sites = {
	accept: (id: string, subdomain?: string) =>
		fetchApi(`/admin/sites/${id}/accept`, academySiteSchema, {
			body: JSON.stringify(subdomain ? { subdomain } : {}),
			method: "POST",
		}),
	list: (status?: AcademySiteStatus) => {
		const qs = status ? `?status=${status}` : "";
		return fetchApi(`/admin/sites${qs}`, academySiteSchema.array());
	},
	reject: (id: string, reason: string) =>
		fetchApi(`/admin/sites/${id}/reject`, academySiteSchema, {
			body: JSON.stringify({ reason }),
			method: "POST",
		}),
};
